import { UserStatus } from 'models/userStatus';
import { evolve } from 'ramda';
import { appendZone, parseStringDate } from 'common/dateFnsUtils';
import { ButtonProps } from 'antd/lib/button';

export interface AdminUserDTO {
  accountStatus: UserStatus;
  createDate: string;
  login: string;
  userId: number;
}

export type Admin = AdminUserDTO;

export interface AdminUser extends Omit<AdminUserDTO, 'createDate'> {
  createDate: Date;
}

export const mapToAdminUser = (dto: AdminUserDTO): AdminUser =>
  evolve(
    {
      createDate: (date: string) => parseStringDate(appendZone(date)),
    },
    dto
  );

export interface DeleteAdminProps
  extends Omit<ButtonProps, 'onClick' | 'loading' | 'href'> {
  admin: Admin;
  onDeleted?: () => void;
}
